import React, {Component} from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import {pressReleaseDetailPageText as pressReleaseDetailPageText_en} from "../libs/en/texts-press-release-detail-page-lib";
import {homePageText as homePageText_en} from "../libs/en/texts-home-page-lib";
import parse from "html-react-parser";
import {Helmet} from 'react-helmet';
import {Link} from "react-router-dom";

export class PressReleaseDetail extends Component {

    constructor(props) {
        super(props);
        // Press releases are always in English - use EN text for all locales
        this.state = {
            language: this.props.language,
            pressReleaseDetailPageText: pressReleaseDetailPageText_en,
            homePageText: homePageText_en,
            prefix: '',
        };
    }

    setLanguageVars() {
        if (this.state.language !== this.props.language) {
            // Press releases are always in English - keep EN text
            this.setState({
                language: this.props.language,
                pressReleaseDetailPageText: pressReleaseDetailPageText_en,
                homePageText: homePageText_en,
                prefix: '',
            });
        }
    }

    componentDidMount() {
        this.setLanguageVars();
        window.scrollTo(0, 0);
    }

    componentDidUpdate() {
        this.setLanguageVars();
    }

    formatDateToUppercase(dateString) {
        if (!dateString) return '';
        return dateString.toUpperCase();
    }

    getPressReleaseData() {
        const { match } = this.props;
        const pressReleaseId = match.params.id;
        // Press releases are always in English
        const homeText = homePageText_en;
        
        // Map press release data based on ID
        const pressReleaseMap = {
            'liberty-launch': {
                date: this.formatDateToUppercase(homeText.dateLibertyLaunchPressRelease),
                title: homeText.headingLibertyLaunchPressRelease,
                subtitle: homeText.subtitleLibertyLaunchPressRelease || `Cambridge, UK and Burgdorf, CH – ${homeText.dateLibertyLaunchPressRelease || ''}`,
                introduction: homeText.introLibertyLaunchPressRelease || homeText.textLibertyLaunchPressRelease,
                content: '',
                detailedDescription: homeText.detailedDescriptionLibertyLaunchPressRelease || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: '',
                reference: '',
                about: '',
                contact: '',
                source: homeText.sourceLibertyLaunchPressRelease || 'CamDiab Ltd and mylife Diabetes Care',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/camaps_liberty_launch-pr.pdf',
                fileName: 'camaps_liberty_launch-pr.pdf',
                downloadDisabled: true
            },
            'companion-ios': {
                date: this.formatDateToUppercase(homeText.dateCompanionIOSPressRelease),
                title: homeText.headingCompanionIOSPressRelease,
                subtitle: homeText.subtitleCompanionIOSPressRelease || `Cambridge, UK, ${homeText.dateCompanionIOSPressRelease || ''}`,
                introduction: homeText.introCompanionIOSPressRelease || homeText.textCompanionIOSPressRelease,
                content: homeText.contentCompanionIOSPressRelease || '',
                detailedDescription: homeText.detailedDescriptionCompanionIOSPressRelease || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: homeText.additionalInfoCompanionIOSPressRelease || '',
                reference: homeText.referenceCompanionIOSPressRelease || '',
                about: homeText.aboutCompanionIOSPressRelease || this.state.pressReleaseDetailPageText.defaultAbout,
                contact: homeText.contactCompanionIOSPressRelease || this.state.pressReleaseDetailPageText.defaultContact,
                source: homeText.sourceCompanionIOSPressRelease || 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/PRESS_RELEASE_CamDiab_Announce_iPhone_Companion.pdf',
                fileName: 'PRESS_RELEASE_CamDiab_Announce_iPhone_Companion.pdf'
            },
            'ios-wave2': {
                date: this.formatDateToUppercase(homeText.dateIOSPressReleaseWave2),
                title: homeText.headingIOSPressReleaseWave2,
                subtitle: homeText.subtitleIOSPressReleaseWave2 || `Cambridge, UK, ${homeText.dateIOSPressReleaseWave2 || ''}`,
                introduction: homeText.introIOSPressReleaseWave2 || homeText.textIOSPressReleaseWave2,
                content: homeText.contentIOSPressReleaseWave2 || '',
                detailedDescription: homeText.detailedDescriptionIOSPressReleaseWave2 || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: homeText.additionalInfoIOSPressReleaseWave2 || '',
                reference: homeText.referenceIOSPressReleaseWave2 || '',
                about: homeText.aboutIOSPressReleaseWave2 || this.state.pressReleaseDetailPageText.defaultAbout,
                contact: homeText.contactIOSPressReleaseWave2 || this.state.pressReleaseDetailPageText.defaultContact,
                source: homeText.sourceIOSPressReleaseWave2 || 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/250610__Ypsomed_Press_Release_iOS_wave2_final.pdf',
                fileName: 'Ypsomed_Press_Release_iOS_wave2_final.pdf'
            },
            'ios-uk': {
                date: this.formatDateToUppercase(homeText.dateIOSPressReleaseUK),
                title: homeText.headingIOSPressReleaseUK,
                subtitle: homeText.subtitleIOSPressReleaseUK || `Cambridge, UK, ${homeText.dateIOSPressReleaseUK || ''}`,
                introduction: homeText.introIOSPressReleaseUK || homeText.textIOSPressReleaseUK,
                content: homeText.contentIOSPressReleaseUK || '',
                detailedDescription: homeText.detailedDescriptionIOSPressReleaseUK || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: homeText.additionalInfoIOSPressReleaseUK || '',
                reference: homeText.referenceIOSPressReleaseUK || '',
                about: homeText.aboutIOSPressReleaseUK || this.state.pressReleaseDetailPageText.defaultAbout,
                contact: homeText.contactIOSPressReleaseUK || this.state.pressReleaseDetailPageText.defaultContact,
                source: homeText.sourceIOSPressReleaseUK || 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/CamAPS_FX_iOS_press_release_UK.pdf',
                fileName: 'CamAPS_FX_iOS_press_release_UK.pdf'
            },
            'npid-hcl-pregnancy': {
                date: this.formatDateToUppercase(homeText.dateNpidHcl260720PressRelease),
                title: homeText.headingNpidHcl260720PressRelease,
                subtitle: homeText.subtitleNpidHcl260720PressRelease || `Cambridge, UK – ${homeText.dateNpidHcl260720PressRelease || ''}`,
                introduction: homeText.introNpidHcl260720PressRelease || '',
                content: homeText.contentNpidHcl260720PressRelease || '',
                detailedDescription: homeText.detailedDescriptionNpidHcl260720PressRelease || '',
                additionalInfo: homeText.additionalInfoNpidHcl260720PressRelease || '',
                reference: homeText.referenceNpidHcl260720PressRelease || '',
                about: homeText.aboutNpidHcl260720PressRelease || this.state.pressReleaseDetailPageText.defaultAbout,
                contact: homeText.contactNpidHcl260720PressRelease || this.state.pressReleaseDetailPageText.defaultContact,
                source: homeText.sourceNpidHcl260720PressRelease || 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/npid_hcl_Analysis_260720.pdf',
                fileName: 'npid_hcl_Analysis_260720.pdf'
            },
            'dexcom-g7': {
                date: this.formatDateToUppercase(homeText.dateDexcomG7PressRelease),
                title: homeText.headingDexcomG7PressRelease,
                subtitle: homeText.subtitleDexcomG7PressRelease || `Cambridge, UK, ${homeText.dateDexcomG7PressRelease || ''}`,
                introduction: homeText.introDexcomG7PressRelease || homeText.textDexcomG7PressRelease,
                content: homeText.contentDexcomG7PressRelease || '',
                detailedDescription: homeText.detailedDescriptionDexcomG7PressRelease || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: homeText.additionalInfoDexcomG7PressRelease || '',
                reference: homeText.referenceDexcomG7PressRelease || '',
                about: '',
                contact: this.state.pressReleaseDetailPageText.defaultContact,
                source: 'mylife Diabetes Care, CamDiab Ltd and Dexcom, Inc.',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/mylife_CamDiab_Dexcom_G7_launch_release_260603.pdf',
                fileName: 'mylife_CamDiab_Dexcom_G7_launch_release_260603.pdf'
            },
            'liberty-260310': {
                date: this.formatDateToUppercase(homeText.dateLiberty260310PressRelease),
                title: homeText.headingLiberty260310PressRelease,
                subtitle: homeText.subtitleLiberty260310PressRelease || `Cambridge, UK, ${homeText.dateLiberty260310PressRelease || ''}`,
                introduction: homeText.introLiberty260310PressRelease || homeText.textLiberty260310PressRelease,
                content: homeText.contentLiberty260310PressRelease || '',
                detailedDescription: homeText.detailedDescriptionLiberty260310PressRelease || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: homeText.additionalInfoLiberty260310PressRelease || '',
                reference: homeText.referenceLiberty260310PressRelease || '',
                about: homeText.aboutLiberty260310PressRelease || this.state.pressReleaseDetailPageText.defaultAbout,
                contact: homeText.contactLiberty260310PressRelease || this.state.pressReleaseDetailPageText.defaultContact,
                source: homeText.sourceLiberty260310PressRelease || 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/PRESS%20RELEASE%20CamAPS%20Liberty_260310.pdf',
                fileName: 'PRESS RELEASE CamAPS Liberty_260310.pdf'
            },
            'canada-ios': {
                date: this.formatDateToUppercase(homeText.dateCanadaIOSPressRelease),
                title: homeText.headingCanadaIOSPressRelease,
                subtitle: homeText.subtitleCanadaIOSPressRelease || `Cambridge, UK, ${homeText.dateCanadaIOSPressRelease || ''}`,
                introduction: homeText.introCanadaIOSPressRelease || homeText.textCanadaIOSPressRelease,
                content: homeText.contentCanadaIOSPressRelease || '',
                detailedDescription: homeText.detailedDescriptionCanadaIOSPressRelease || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: homeText.additionalInfoCanadaIOSPressRelease || '',
                reference: homeText.referenceCanadaIOSPressRelease || '',
                about: homeText.aboutCanadaIOSPressRelease || this.state.pressReleaseDetailPageText.defaultAbout,
                contact: homeText.contactCanadaIOSPressRelease || this.state.pressReleaseDetailPageText.defaultContact,
                source: homeText.sourceCanadaIOSPressRelease || 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/Press-release_Canada_iOS_FSL3.pdf',
                fileName: 'Press-release_Canada_iOS_FSL3.pdf'
            },
            'liberty-eu-mdr': {
                date: this.formatDateToUppercase(homeText.dateInitialLibertyIOSPressRelease),
                title: homeText.headingInitialLibertyIOSPressRelease,
                subtitle: homeText.subtitleInitialLibertyIOSPressRelease || `Cambridge, UK, ${homeText.dateInitialLibertyIOSPressRelease || ''}`,
                introduction: homeText.introInitialLibertyIOSPressRelease || homeText.textInitialLibertyIOSPressRelease,
                content: homeText.contentInitialLibertyIOSPressRelease || '',
                detailedDescription: homeText.detailedDescriptionInitialLibertyIOSPressRelease || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: homeText.additionalInfoInitialLibertyIOSPressRelease || '',
                reference: homeText.referenceInitialLibertyIOSPressRelease || '',
                about: homeText.aboutInitialLibertyIOSPressRelease || this.state.pressReleaseDetailPageText.defaultAbout,
                contact: homeText.contactInitialLibertyIOSPressRelease || this.state.pressReleaseDetailPageText.defaultContact,
                source: homeText.sourceInitialLibertyIOSPressRelease || 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/press-release-fully-closed-loop-approval-20260108.pdf',
                fileName: 'press-release-fully-closed-loop-approval-20260108.pdf'
            },
            'ios': {
                date: this.formatDateToUppercase(homeText.dateIOSPressRelease),
                title: homeText.headingIOSPressRelease,
                subtitle: homeText.subtitleIOSPressRelease || `Cambridge, UK, ${homeText.dateIOSPressRelease || ''}`,
                introduction: homeText.introIOSPressRelease || homeText.textIOSPressRelease,
                content: homeText.contentIOSPressRelease || '',
                detailedDescription: homeText.detailedDescriptionIOSPressRelease || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: homeText.additionalInfoIOSPressRelease || '',
                reference: homeText.referenceIOSPressRelease || '',
                about: homeText.aboutIOSPressRelease || this.state.pressReleaseDetailPageText.defaultAbout,
                contact: homeText.contactIOSPressRelease || this.state.pressReleaseDetailPageText.defaultContact,
                source: homeText.sourceIOSPressRelease || 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/CamAPS_FX_iOS_press_release.pdf',
                fileName: 'CamAPS_FX_iOS_press_release.pdf'
            },
            'fda': {
                date: this.formatDateToUppercase(homeText.dateFDAPressRelease),
                title: homeText.headingFDAPressRelease,
                subtitle: homeText.subtitleFDAPressRelease || `Cambridge, UK, ${homeText.dateFDAPressRelease || ''}`,
                introduction: homeText.introFDAPressRelease || homeText.textFDAPressRelease,
                content: homeText.contentFDAPressRelease || '',
                detailedDescription: homeText.detailedDescriptionFDAPressRelease || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: homeText.additionalInfoFDAPressRelease || '',
                reference: homeText.referenceFDAPressRelease || '',
                about: homeText.aboutFDAPressRelease || this.state.pressReleaseDetailPageText.defaultAbout,
                contact: homeText.contactFDAPressRelease || this.state.pressReleaseDetailPageText.defaultContact,
                source: homeText.sourceFDAPressRelease || 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/CamDiab+secures+FDA+approval+for+advanced+adaptive+hybrid+closed-loop+app+CamAPS+FX.pdf',
                fileName: 'CamDiab-secures-FDA-approval-CamAPS-FX.pdf'
            },
            'libre': {
                date: this.formatDateToUppercase(homeText.dateLibrePressRelease),
                title: homeText.headingLibrePressRelease,
                subtitle: homeText.subtitleLibrePressRelease || `Cambridge, UK, ${homeText.dateLibrePressRelease || ''}`,
                introduction: homeText.introLibrePressRelease || homeText.textLibrePressRelease,
                content: homeText.contentLibrePressRelease || '',
                detailedDescription: homeText.detailedDescriptionLibrePressRelease || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: homeText.additionalInfoLibrePressRelease || '',
                reference: homeText.referenceLibrePressRelease || '',
                about: homeText.aboutLibrePressRelease || this.state.pressReleaseDetailPageText.defaultAbout,
                contact: homeText.contactLibrePressRelease || this.state.pressReleaseDetailPageText.defaultContact,
                source: homeText.sourceLibrePressRelease || 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/221125_Ypsomed_PressRelease_FreeStyle_Libre3_final%20(003).pdf',
                fileName: 'Ypsomed_PressRelease_FreeStyle_Libre3.pdf'
            },
            'adc': {
                date: this.formatDateToUppercase(homeText.dateAdcPressRelease),
                title: homeText.headingAdcPressRelease,
                subtitle: homeText.subtitleAdcPressRelease || `Cambridge, UK, ${homeText.dateAdcPressRelease || ''}`,
                introduction: homeText.introAdcPressRelease || homeText.textAdcPressRelease,
                content: homeText.contentAdcPressRelease || '',
                detailedDescription: homeText.detailedDescriptionAdcPressRelease || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: homeText.additionalInfoAdcPressRelease || '',
                reference: homeText.referenceAdcPressRelease || '',
                about: homeText.aboutAdcPressRelease || this.state.pressReleaseDetailPageText.defaultAbout,
                contact: homeText.contactAdcPressRelease || this.state.pressReleaseDetailPageText.defaultContact,
                source: homeText.sourceAdcPressRelease || 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/ADC_CamDiab_Ypsomed_Joint_Press_Release_4.24.22.pdf',
                fileName: 'ADC_CamDiab_Ypsomed_Joint_Press_Release.pdf'
            },
            'ypso': {
                date: this.formatDateToUppercase(homeText.dateYpsoPressRelease),
                title: homeText.headingYpsoPressRelease,
                subtitle: homeText.subtitleYpsoPressRelease || `Cambridge, UK, ${homeText.dateYpsoPressRelease || ''}`,
                introduction: homeText.introYpsoPressRelease || homeText.textYpsoPressRelease,
                content: homeText.contentYpsoPressRelease || '',
                detailedDescription: homeText.detailedDescriptionYpsoPressRelease || this.state.pressReleaseDetailPageText.defaultDetailedDescription,
                additionalInfo: homeText.additionalInfoYpsoPressRelease || '',
                reference: homeText.referenceYpsoPressRelease || '',
                about: homeText.aboutYpsoPressRelease || this.state.pressReleaseDetailPageText.defaultAbout,
                contact: homeText.contactYpsoPressRelease || this.state.pressReleaseDetailPageText.defaultContact,
                source: homeText.sourceYpsoPressRelease || 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/220322_Media_release_EN_final+Ypsomed.pdf',
                fileName: 'Media_release_Ypsomed.pdf'
            },
            'ce-launch': {
                date: this.formatDateToUppercase(homeText.dateCELaunchPressRelease),
                title: homeText.headingCELaunchPressRelease,
                subtitle: `Cambridge, UK, ${homeText.dateCELaunchPressRelease || ''}`,
                introduction: homeText.textCELaunchPressRelease,
                content: '',
                detailedDescription: '',
                additionalInfo: '',
                reference: '',
                about: this.state.pressReleaseDetailPageText.defaultAbout,
                contact: this.state.pressReleaseDetailPageText.defaultContact,
                source: 'CamDiab Ltd',
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/Press+release+-+launch+16+March+2020.pdf',
                fileName: 'Press+release+-+launch+16+March+2020.pdf'
            }
        };

        return pressReleaseMap[pressReleaseId] || null;
    }

    render() {
        const pressRelease = this.getPressReleaseData();

        if (!pressRelease) {
            return (
                <div>
                    <Header props={this.props}/>
                    <div className="container" style={{ padding: '60px 0', textAlign: 'center' }}>
                        <h1>Press Release Not Found</h1>
                        <Link to="/press-releases">← Back to Press Releases</Link>
                    </div>
                    <Footer props={this.props}/>
                </div>
            );
        }

        return (
            <>
            <div className="press-release-detail-page">
                <Helmet>
                    <title>{parse(pressRelease.title)} - CamDiab</title>
                    <meta name="title" content={parse(pressRelease.title)}/>
                    <meta name="description" content={parse(pressRelease.introduction || '')}/>
                    <meta property="og:locale" content={this.state.pressReleaseDetailPageText.localeMeta}/>
                </Helmet>
                <Header props={this.props}/>
                
                {/* Press Release Detail Section */}
                <section className="press-release-detail-section">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 press-release-detail-content">
                                {/* Date */}
                                <div className="press-release-detail-date">
                                    {pressRelease.date}
                                </div>

                                {/* Title */}
                                <h1 className="press-release-detail-title">
                                    {parse(pressRelease.title)}
                                </h1>

                                {/* Subtitle/Location */}
                                {pressRelease.subtitle && (
                                    <div className="press-release-detail-subtitle">
                                        {parse(pressRelease.subtitle)}
                                    </div>
                                )}

                                {/* Introduction */}
                                {pressRelease.introduction && (
                                    <div className="press-release-detail-introduction">
                                        {parse(pressRelease.introduction)}
                                    </div>
                                )}

                                {/* Main Content */}
                                {pressRelease.content && (
                                    <div className="press-release-detail-body">
                                        {parse(pressRelease.content)}
                                    </div>
                                )}

                                {/* Extended Description/Details */}
                                {pressRelease.detailedDescription && (
                                    <div className="press-release-detail-description">
                                        {parse(pressRelease.detailedDescription)}
                                    </div>
                                )}

                                {/* Additional Information */}
                                {pressRelease.additionalInfo && (
                                    <div className="press-release-detail-additional">
                                        {parse(pressRelease.additionalInfo)}
                                    </div>
                                )}

                                {/* Reference */}
                                {pressRelease.reference && (
                                    <div className="press-release-detail-reference">
                                        {parse(pressRelease.reference)}
                                    </div>
                                )}

                                {/* About Section */}
                                {pressRelease.about && (
                                    <div className="press-release-detail-about">
                                        {parse(pressRelease.about)}
                                    </div>
                                )}

                                {/* Contact */}
                                {pressRelease.contact && (
                                    <div className="press-release-detail-contact">
                                        {parse(pressRelease.contact)}
                                    </div>
                                )}

                                {/* Divider */}
                                <div className="press-release-detail-divider"></div>

                                {/* Source */}
                                <div className="press-release-detail-source">
                                    SOURCE: {pressRelease.source}
                                </div>
                            </div>


                                  {/* Download Link */}
                        <div className="row justify-content-center">
                            <div className="col-12 press-release-detail-download-wrapper">
                                {pressRelease.downloadDisabled ? (
                                <span
                                    className="press-release-detail-download is-disabled"
                                    aria-disabled="true"
                                >
                                      <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4321 6.25919L8.61965 10.8987V0H6.38027V10.8987L1.56778 6.25919L0 7.76961L7.5 15L15 7.76961L13.4321 6.25919Z" fill="#02ACA0"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 17H14V19H1V17Z" fill="#02ACA0"/>
                                                </svg>

                                    <span>{this.state.pressReleaseDetailPageText.download}</span>
                                </span>
                                ) : (
                                <a 
                                    href={pressRelease.downloadUrl} 
                                    className="press-release-detail-download"
                                    download={pressRelease.fileName}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                      <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4321 6.25919L8.61965 10.8987V0H6.38027V10.8987L1.56778 6.25919L0 7.76961L7.5 15L15 7.76961L13.4321 6.25919Z" fill="#02ACA0"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 17H14V19H1V17Z" fill="#02ACA0"/>
                                                </svg>

                                    <span>{this.state.pressReleaseDetailPageText.download}</span>
                                </a>
                                )}
                            </div>
                        </div>

                        
                        </div>

                  
                    </div>
                </section>
                </div>
                <Footer props={this.props}/>
            </>
        );
    }
}

